import { ToolBar as InnerToolBar } from './toolbar';
import { ToolBarActions } from './toolbar-actions';
const ToolBar = InnerToolBar;
ToolBar.Actions = ToolBarActions;
export default ToolBar;
